import { useTranslation } from 'react-i18next'
import { Section } from '../ui/Section'
import { Container } from '../ui/Container'
import { SectionTitle } from '../ui/SectionTitle'
import { motion } from 'framer-motion'
import {
  FileSearch,
  ClipboardCheck,
  Layers,
  Cpu,
  Settings,
  ShieldCheck,
  Truck,
  HeadphonesIcon
} from 'lucide-react'

const icons = [
  FileSearch,
  ClipboardCheck,
  Layers,
  Cpu,
  Settings,
  ShieldCheck,
  Truck,
  HeadphonesIcon
]

export function MethodSteps() {
  const { t } = useTranslation()

  const steps = [
    { key: 'step1', number: '01' },
    { key: 'step2', number: '02' },
    { key: 'step3', number: '03' },
    { key: 'step4', number: '04' },
    { key: 'step5', number: '05' },
    { key: 'step6', number: '06' },
    { key: 'step7', number: '07' },
    { key: 'step8', number: '08' },
  ]

  return (
    <Section variant="primary">
      <Container>
        <SectionTitle
          title={t('home.method.title')}
          subtitle={t('home.method.subtitle')}
          centered
        />

        {/* Steps Grid - 2 columns mobile, 4 columns desktop */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {steps.map((step, index) => {
            const IconComponent = icons[index]
            return (
              <motion.div
                key={step.key}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.4, delay: index * 0.1 }}
                className="relative bg-white rounded-lg p-6 shadow-sm hover:shadow-md transition-all duration-300 group overflow-hidden"
              >
                {/* Number - Large faded number with navbar color */}
                <span className="absolute top-4 left-4 text-5xl font-bold text-dark/25 select-none"
                      style={{ textShadow: '1px 1px 3px rgba(255,255,255,0.95), 0 0 2px rgba(68,68,68,0.15)' }}>
                  {step.number}
                </span>

                {/* Content */}
                <div className="relative pt-12">
                  {/* Icon */}
                  <div className="w-12 h-12 rounded-lg bg-primary/10 flex items-center justify-center mb-4">
                    <IconComponent className="w-6 h-6 text-primary" />
                  </div>

                  {/* Title */}
                  <h3 className="text-dark font-semibold text-lg mb-2">
                    {t(`home.method.steps.${step.key}.title`)}
                  </h3>

                  {/* Description */}
                  <p className="text-gray-600 text-sm leading-relaxed">
                    {t(`home.method.steps.${step.key}.description`)}
                  </p>
                </div>
              </motion.div>
            )
          })}
        </div>
      </Container>
    </Section>
  )
}
